var map = {
	"./i18n/assets_base.properties": [
		5717,
		717
	],
	"./i18n/assets_base_de.properties": [
		9297,
		297
	],
	"./i18n/assets_base_es.properties": [
		1780,
		780
	],
	"./i18n/assets_base_fr.properties": [
		1966,
		966
	],
	"./i18n/assets_base_it.properties": [
		6179,
		713
	],
	"./i18n/assets_base_ja.properties": [
		6201,
		201
	],
	"./i18n/assets_base_ko.properties": [
		5071,
		71
	],
	"./i18n/assets_base_pl.properties": [
		9730,
		730
	],
	"./i18n/assets_base_th.properties": [
		6029,
		29
	],
	"./i18n/assets_base_zh-Hans.properties": [
		5150,
		28
	],
	"./i18n/assets_base_zh-Hant.properties": [
		9927,
		927
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3322;
module.exports = webpackAsyncContext;